import {useMemo} from "react";

import {useLocation} from "@khan/urls";

import {
    useAssignmentData,
    type StudentActivityAssignmentData,
} from "../queries/use-assignment-data.ts";

// useAssignedActivity is a hook that returns the assigned activity data for
// the current URL. If the data is loading or the assignment is not found,
// it returns null.
export const useAssignedActivity = (): StudentActivityAssignmentData | null => {
    const {queryParams} = useLocation();

    const assignmentID: string | null | undefined = useMemo(() => {
        return queryParams["assignment"];
    }, [queryParams]);

    const assignmentDataResult = useAssignmentData(assignmentID);

    if (assignmentDataResult.status !== "ready") {
        return null;
    }

    return assignmentDataResult;
};
